import { Badge } from '@/components/ui/badge'
import { cn } from '@/lib/utils'
import { tagColor, tagLabel } from './tags'

const NewsTagBadge = ({
  tag,
  className,
  style,
  ...props
}: { tag: string } & React.HTMLAttributes<HTMLDivElement>) => {
  const color = tagColor(tag)

  return (
    <Badge
      variant='outline'
      className={cn('font-medium', className)}
      style={{
        color,
        borderColor: color
          ? `color-mix(in oklch, ${color} 45%, transparent)`
          : undefined,
        backgroundColor: color
          ? `color-mix(in oklch, ${color} 10%, transparent)`
          : undefined,
        ...style,
      }}
      {...props}
    >
      {tagLabel(tag)}
    </Badge>
  )
}

export default NewsTagBadge
